import $ from 'jquery';
import Portfolio from '../Portfolio/index';
import { createRoot } from 'react-dom/client';
import React, { useState, useEffect } from 'react';

export default function StudentList() {
    const [ bolsistas, setBolsistas ] = useState([]);
    const [ cards, setCards ] = useState(document.querySelectorAll('.Cards li'));

    useEffect(() => {
        const ul = document.querySelector('ul.Card-wrapper');

        const updateCards = e => {
            const cards = e.detail;

            if (cards.length) {
                setCards(current => [...current, ...cards]);
            }
        };

        ul.addEventListener('load-more:append', updateCards);

        return () => ul.removeEventListener('load-more:append', updateCards);
    }, []);

    useEffect(() => {
        const updateCards = async () => {
            $(cards).find('.CandidateList-title').each((i, title) => title.textContent = title.textContent.split(' ').shift());

            const postIds = $(cards).get().map(card => card.className.split(' ').find(c => c.startsWith('post-')));
            const ids = postIds.map(postId => postId.split('-').pop());

            setBolsistas(await getBolsistas(ids));
        };

        updateCards();
    }, [ cards ]);

    if (!bolsistas.length) {
        return;
    }

    const portfolios = bolsistas.map(bolsista => (
        <Portfolio bolsista={bolsista} openModalButton={`.Cards li.post-${ bolsista.id } .CandidateList-btnCurriculo a`} key={bolsista.id}/>
    ));

    return (
        <div>
            {portfolios}
        </div>
    );
}

async function getBolsistas(ids) {
	return new Promise((resolve, reject) => {
		$.ajax({
			method: 'GET',
			url: `/wp-json/wp/v2/scholarship?per_page=100&include=${ ids.join(',') }`,
			success: resolve,
			error: reject
		});
	});
}

const container = document.getElementById('StudentList-root');

if (container) {
  const root = createRoot(container);
  root.render(<StudentList />);
}
